import { action } from 'satcheljs';

/**
 * Signal for force-refreshing the mini-month in left nav
 */
export const refreshDayPicker = action('refreshDayPicker');
